<template>
  <div>
    <Header />

    <header class="header6">
      <div class="container">
        <div class="header6-cont">
          <div class="mundial-cont">
              <div class="mundial-cont-wrp">
                <h1>{{ $tc('world_cup_page.mundial_cont_h1') }}</h1>
                <h2>{{ $tc('world_cup_page.mundial_cont_h2') }}</h2>
                <p>{{ $tc('world_cup_page.mundial_cont_p') }}</p>
                <h4>{{ $tc('world_cup_page.mundial_cont_h4') }}</h4>
                  <ul>
                    <li>● {{ $tc('world_cup_page.mundial_cont_li1') }}</li>
                    <li>● {{ $tc('world_cup_page.mundial_cont_li2') }}</li>
                    <li>● {{ $tc('world_cup_page.mundial_cont_li3') }}</li>
                  </ul>
                <p>{{ $tc('world_cup_page.mundial_cont_lip') }}</p>
              </div>
             <a href="https://secure.finanleads.com/register" target="_blank"><button class="mundial-btn">{{ $tc('world_cup_page.mundial_cont_btn') }}</button></a>
             <router-link :to="{ name: 'Condiciones' }" class="small-p">{{ $tc('world_cup_page.mundial_cont_a') }}</router-link>
          </div>
        </div>
      </div>
    </header>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'

export default {
  name: 'Mundial',

  components: {
    Header,
    Footer
  },

  created () {
    document.title = `Mundial - ${process.env.VUE_APP_TITLE}`
  }
}
</script>
